<template>
  <main class="container main-location">
    <section class="wellcome-section">
      <img class="topic-icon" src="@/assets/images/location/culture/topic_icon.svg" alt="" />
      <h2>Cultural Facilities</h2>
      <p>Cultural spaces that attract many visitors require protection from viruses and bacteria and should also enhance the space's prestige.</p>
      <div class="topic-tags">
        <span class="tag"> #Cinemas </span>
        <span class="tag"> #Exhibition Halls </span>
        <span class="tag"> #Theaters </span>
        <span class="tag"> #etc </span>
      </div>
    </section>

    <img :src="require(`@/assets/images/location/culture/main${mobileCheck ? '_mo' : ''}.png`)" class="main-img" alt="" />

    <section class="location-content">
      <section class="location-content-1">
        <h3>Are these concerns <br class="mo_show" />relevant to you?</h3>
        <div class="concerns-card-list">
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_virus.svg" alt="" />
            <div class="title">
              <h3>Reliable Disinfection Against Viruses and Harmful Bacteria</h3>
            </div>
            <p class="description">Activities such as removing masks or spreading droplets occur often, making me worry everyday.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_speaker.svg" alt="" />
            <div class="title">
              <h3>Distinguished Space Marketing</h3>
            </div>
            <p class="description">I aim to create an elegant space with a luxurious scent, making it appealing for longer stays.</p>
          </div>
          <div class="concerns-card">
            <img src="@/assets/images/location/card_img_clean.svg" alt="" />
            <div class="title">
              <h3>Clean and Safe Indoor Environment</h3>
            </div>
            <p class="description">I am concerned about pests entering from outside and mites breeding on chairs.</p>
          </div>
        </div>
      </section>

      <section class="location-content-2">
        <h3>With CESCO, <br class="mo_show" />Find Your Solution.</h3>
        <div>
          <div class="border-content">
            <h4>Deliver a clean and safe indoor environment through our organized services.</h4>
            <p>
              Is intensive virus management essential in indoor areas frequented by the public for dining and other activities? CESCO offers a clean
              and safe indoor environment with personalized services designed through 1:1 consultation visits.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/culture/border_content_02.png" alt="" />
          </div>
          <div>
            <img src="@/assets/images/location/culture/border_content_03.png" alt="" />
          </div>
          <div class="border-content">
            <h4>We ensure comfort throughout our customer service, from start to finish, harmonizing with the space.</h4>
            <p>We create uninterrupted cultural experiences with micro-molecules and minimal noise.</p>
          </div>
          <div class="border-content">
            <h4>We conduct direct diagnostics and disinfection in areas prone to contact with an unspecified number of people.</h4>
            <p>
              CESCO experts thoroughly inspect and disinfect everything from seats frequented by numerous people and communal utensils, to every door
              handle, using chemicals approved by the Ministry of Environment.
            </p>
          </div>
          <div>
            <img src="@/assets/images/location/culture/border_content_04.png" alt="" />
          </div>
        </div>
      </section>
    </section>

    <section class="location-swiper">
      <div>
        <h3>
          CESCO’s Advanced Science Ensures 24/7
          <br />
          Management of Hazardous Elements Within Spaces
        </h3>

        <span class="swiper-navigation">
          <button type="button" class="me-swiper-button-prev" :disabled="prevDisabled" @click="slidePrev">
            <img src="@/assets/images/icons/Left Circle.svg" />
          </button>
          <button type="button" class="me-swiper-button-next" :disabled="nextDisabled" @click="slideNext">
            <img src="@/assets/images/icons/Right Circle.svg" />
          </button>
        </span>
      </div>

      <swiper ref="swiperRef" :slides-per-view="'auto'" :centered-slides="true" @slideChange="onSlideChange">
        <swiper-slide v-for="(item, index) in slildeList" :key="`product-slide-${index}`">
          <img :src="item.backgroundImg" alt="" />
          <button
            v-for="(productItem, productIndex) in item.products"
            :key="`product-slide-product-${productIndex}`"
            @click="handleButtonClick(productItem.productInfo)"
            :style="`
              top: ${mobileCheck ? productItem.mobilePosY : productItem.posY};
              left: ${mobileCheck ? productItem.mobilePosX : productItem.posX};
              transform: ${mobileCheck ? 'translate(-50%, -50%)' : 'none'};`"
          >
            <img src="@/assets/images/icons/add-icon-primary.svg" alt="" />
          </button>
        </swiper-slide>

        <button class="swiper-button-prev" :disabled="prevDisabled" @click="slidePrev"></button>
        <button class="swiper-button-next" :disabled="nextDisabled" @click="slideNext"></button>
      </swiper>
    </section>

    <section class="location-footer">
      <section class="add-section">
        <h3>CESCO <br class="mo_show" />Certification Mark</h3>
        <p>
          CESCO provides promotional materials to businesses managing various hazards such as pests, viruses, and water quality. These materials help
          businesses be recognized by customers as safe and hygienic.
        </p>
        <img src="@/assets/images/location/certification_mark.png" alt="" />
      </section>

      <h3>
        Top 3 Solutions <br class="mo_show" />Most Requested by
        <br />
        Service Facilities
      </h3>

      <div class="solution-card-list">
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_viruscare.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Viruscare
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Manual disinfection and advanced equipment for 24-hour sterilization</p>
            </div>
            <router-link to="/solution/service/virusCare"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_scent.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>Fragrance Consulting Solution</h3>
              </div>
              <p class="description">Develop a lasting and symbolic fragrance that becomes synonymous with your business.</p>
            </div>

            <router-link to="/solution/service/scent"> Learn More </router-link>
          </div>
        </div>
        <div class="solution-card">
          <img src="@/assets/images/location/solution_card_total.svg" alt="" />
          <div class="content">
            <div>
              <div class="title">
                <h3>
                  Integrated
                  <br />
                  Pest Control
                  <br />
                  Solution
                </h3>
              </div>
              <p class="description">Pest control for cockroaches, ants, and rats</p>
            </div>

            <router-link to="/solution/service/total"> Learn More </router-link>
          </div>
        </div>
      </div>
    </section>
  </main>

  <LocationModalView :modal-state="modalState" @close-modal="closeModal" :productData="productData" />
</template>

<script setup>
import { inject, ref } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { useSlide, useModal } from '@/hooks'
import LocationModalView from '@/components/common/LocationModalView.vue'

const { prevDisabled, nextDisabled, swiperRef, onSlideChange, slidePrev, slideNext } = useSlide()
const { modalState, openModal, closeModal } = useModal()

const mobileCheck = inject('mobileCheck')

const productData = ref({})

const slildeList = [
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_01.png'),
    products: [
      {
        posX: '10.125rem',
        posY: '24.8075rem',
        mobilePosX: '14%',
        mobilePosY: '69%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_02.png'),
    products: [
      {
        posX: '49.8125rem',
        posY: '12.37rem',
        mobilePosX: '66%',
        mobilePosY: '36%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_02.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_03.png'),
    products: [
      {
        posX: '8.3125rem',
        posY: '9.37rem',
        mobilePosX: '10%',
        mobilePosY: '32%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_03.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_04.png'),
    products: [
      {
        posX: '41.25rem',
        posY: '26.8113rem',
        mobilePosX: '54.5%',
        mobilePosY: '79%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_01.png'),
          name: 'CESCO\nAir Sterilizer',
          description:
            'This system can manage large multi-use spaces using the oversized Virus Pre-attack System<sup>TM</sup>.\n*Select an appropriate air sterilizer based on the spatial environment.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_05.png'),
    products: [
      {
        posX: '8.1875rem',
        posY: '24.3075rem',
        mobilePosX: '13%',
        mobilePosY: '64%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_04.png'),
          name: 'CESCO\nAutomatic Hand Sanitizer Sanigenic',
          description: 'Removes more than 99.999% of harmful bacteria on hands in public places, preventing cross-contamination.'
        }
      }
    ]
  },
  {
    backgroundImg: require('@/assets/images/location/culture/background_img_06.png'),
    products: [
      {
        posX: '46.1875rem',
        posY: '10.5575rem',
        mobilePosX: '61%',
        mobilePosY: '31%',
        productInfo: {
          image: require('@/assets/images/location/culture/product_img_05.png'),
          name: 'CESCO\nSpace Fragrancer Airperfume',
          description: 'This product uniformly scents large spaces with fragrances designed specifically for various types of businesses.'
        }
      }
    ]
  }
]

/**
 * 슬라이드 버튼 클릭
 * @param {object} item
 */
const handleButtonClick = item => {
  productData.value = item
  openModal()
}
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/location.scss';
</style>
